function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_883",
  "data-name": "Group 883",
  transform: "translate(-521.029 -1155.109)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_141",
  "data-name": "Ellipse 141",
  cx: 26.5,
  cy: 26.5,
  r: 26.5,
  transform: "translate(529 1166)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("text", {
  id: "_",
  "data-name": "+",
  transform: "translate(572 1154) rotate(45)",
  fill: "#464a55",
  fontSize: 55,
  fontFamily: "Nunito-SemiBold, Nunito",
  fontWeight: 600
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 56
}, "+")));

var SvgCloseAccountIcon = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76.368,
    height: 76.368,
    viewBox: "0 0 76.368 76.368",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCloseAccountIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/close-account-icon.064e64bf.svg";
export { ForwardRef as ReactComponent };